import React from "react";
import { Sparkles, Lightbulb } from "lucide-react";

const DashboardInsights = ({ insights = [] }) => {
  if (!insights.length) return null;

  return (
    <div className="group relative overflow-hidden rounded-2xl bg-white border border-slate-200 shadow-md hover:shadow-xl transition-all duration-500 mb-8">

      {/* Left Accent */}
      <div className="absolute left-0 top-0 h-full w-1 bg-emerald-500 group-hover:w-2 transition-all duration-300" />

      {/* Hover Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-50 via-white to-cyan-50 opacity-0 group-hover:opacity-100 transition-all duration-500" />

      <div className="relative p-6">

        {/* Header */}
        <div className="flex items-center justify-between border-b border-slate-200 pb-3 mb-2">

          <div>
            <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
              <Sparkles
                size={24}
                className="text-emerald-500"
              />
              AI Insights
            </h2>

            <p className="text-sm text-slate-500 mt-1">
              Automatically generated recommendations based on your data
            </p>
          </div>

          <div className="h-12 w-12 rounded-xl bg-emerald-100 flex items-center justify-center group-hover:rotate-12 transition-all duration-500">
            <Lightbulb
              size={24}
              className="text-emerald-600"
            />
          </div>

        </div>

        {/* Insights */}
        <div className="space-y-3">

          {insights.map((item, index) => (
            <div
              key={index}
              className="flex items-center gap-4 rounded-xl border border-emerald-100 bg-emerald-50/60 px-4 py-1 transition-all duration-300 hover:bg-white hover:shadow-md hover:border-emerald-300"
            >

              <div className="mt-1 flex h-9 w-9 items-center justify-center rounded-full bg-emerald-500 text-white">
                <Sparkles size={14} />
              </div>

              <div className="flex-1">
                <p className="text-sm leading-7 text-slate-700">
                  {item}
                </p>
              </div>

            </div>
          ))}

        </div>

      </div>
    </div>
  );
};

export default DashboardInsights;